import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const BulkToggleTagsOnDeliverablesMutation = (input, callback) => {
  commitMutation(getEnvironment(), {
    mutation: graphql`
      mutation BulkToggleTagsOnDeliverablesMutation($input: ToggleDeliverablesTagsInput!) {
        toggleDeliverablesTags(input: $input) {
          deliverables {
            id
          }
        }
      }
    `,
    variables: {
      input
    },
    onCompleted: (response, errors) => {
      callback(response.deliverables, errors);
    },
    onError: err => console.error(err)
  });
};

export default BulkToggleTagsOnDeliverablesMutation;
